import { Box, Heading, Text } from "rebass";
import styled from "styled-components";
import * as moment from "moment";

import { DynamicNextLink } from "../components/dynamic-next-link";

const RelatedEvents = ({ events }) => {
  const EventModule = ({ start_date, end_date, title, details, link }) => {
    // Check if event spans multiple days
    const startDateStr = moment(start_date).format("M.D");
    const endDateStr = moment(end_date).format("M.D");
    const dateStr =
      startDateStr === endDateStr
        ? startDateStr
        : `${startDateStr} - ${endDateStr} `;

    return (
      <Box mt={4}>
        <Text fontSize={[4, 5]} fontFamily="boldItalic" color="blue.2">
          {dateStr}
        </Text>

        <S_Heading
          fontSize={[4, 5]}
          fontFamily="semibold"
          color="blue.2"
          lineHeight={1.125}
          letterSpacing={3}
        >
          <S_DynamicNextLink link={link}>{title}jhbd</S_DynamicNextLink>
        </S_Heading>

        <Text mt={3}>{details}</Text>

        <Text mt={3}>
          <S_DynamicNextLink link={link}>View more</S_DynamicNextLink>
        </Text>
      </Box>
    );
  };

  return (
    <Text py={4} fontSize={1} fontFamily="medium" color="blue.1">
      <Text>Related Events:</Text>
      {events.map((event, index) => (
        <EventModule
          key={index}
          start_date={event.data.start_date}
          end_date={event.data.end_date}
          title={event.data.title}
          details={event.data.details}
          link={{
            internal: true,
            href: `/event?uid=${event.uid}`,
            as: `/events/${event.uid}`
          }}
        />
      ))}
    </Text>
  );
};

const S_Heading = styled(Heading)`
  text-transform: uppercase;
`;

const S_DynamicNextLink = styled(DynamicNextLink)`
  a:hover {
    text-decoration: underline;
  }
`;

export { RelatedEvents };
